
import { MainLayout } from "../MainLayout";
import AboutUsSec1 from "./AboutUsSec1";
import AboutUsSec2 from "./AboutUsSec2";
import { Footer } from "../Footer";
import { AboutUsIntro } from "./AboutUsIntro";
import { AboutUsMission } from "./AboutUsMission";
import { AboutUsCredentials } from "./AboutUsCredentials";
import { AboutUsSec0 } from "./AboutUsSec0";
import { AboutUsVision } from "./AboutUsVision";

export const AboutUs = () => {

  const data = {
    head: "How We Make B2B Travel Work on the Ground ",
    text: [
      "Delivering on travel commitments demands clarity, follow-through, and the ability to execute services exactly as planned. At Blueberry DMC, we support travel partners across Africa, Asia, far east, UK, EU and Middle East through structured processes, trusted local supplier networks, and dedicated teams that manage every booking from start to finish. ",
      "Our scope spans leisure travel, group movements, MICE, and corporate itineraries, all handled through confirmed hotel partnerships, seamless transport coordination, and destination-based teams across our DMC destinations. ",
      "Every itinerary is actively monitored from initial planning through to final reconfirmations, ensuring services run without gaps on the ground. We work as a seamless extension of your team,providing practical solutions, consistent communication, and execution that aligns precisely with what has been promised to your clients.",
    ],
  };

  const credentials = [
    {
      id: 1,
      image: "/assets/about-credential-img1.png",
      title: "Local Knowledge and Expertise",
      desc: "The small details that make a travel experience truly memorable are often only known by those with deep local knowledge and expertise. DMCs excel in these areas",
    },
    {
      id: 2,
      image: "/assets/about-credential-img2.png",
      title: "Access to Exclusive Experiences",
      desc: "DMCs can offer exclusive experiences that are only available through their established connections and local expertise. These unique opportunities would otherwise be inaccessible to travel agencies.",
    },
    {
      id: 3,
      image: "/assets/about-credential-img3.png",
      title: "Knowledge of Local Tours & Excursions",
      desc: "What are the must-see attractions in your event’s location? A DMC knows all the local hotspots and can help you book activities, from guided tours to group events, happy hour locations, or optional excursions for attendees.",
    },
    {
      id: 4,
      image: "/assets/about-credential-img4.png",
      title: "Local Expertise and Insight",
      desc: "Want to provide your attendees with a truly memorable experience? DMCs possess local knowledge that uncovers unique local gems and experiences you won’t find through online searches, creating lasting memories for attendees.",
    },
    {
      id: 5,
      image: "/assets/about-credential-img5.png",
      title: "Personalized Service",
      desc: "Personalization is crucial in today’s competitive market. To deliver truly tailored services, you need a diverse product portfolio for each destination. This is where DMCs come in.",
    },
    {
      id: 6,
      image: "/assets/about-credential-img6.png",
      title: "Seamless Travel Coordination",
      desc: "Let your DMC handle all your travel needs, making the process effortless. They can arrange everything from airport transfers to hotel bookings, vehicle rentals, and even ensuring compliance with travel restrictions and safety protocols.",
    },
    {
      id: 7,
      image: "/assets/about-credential-img7.png",
      title: "Connections to Local Vendors and Venues",
      desc: "A reliable DMC comes with an extensive network of trusted local vendors, including top-rated caterers, event venues, and specialized service providers.",
    },
    {
      id: 8,
      image: "/assets/about-credential-img8.png",
      title: "Assistance with Safety Standards",
      desc: "Not sure about local safety guidelines? Your DMC is well- versed in the latest recommendations and can help ensure compliance with local regulations.",
    },
  ];

  return (
    <div>
      <MainLayout
        bgImage={
          'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Banner/Empowering%20Travel%20Partners%20Through%20Curated%20Global%20Journeys.webp")'
        }
        text1={"ABOUT US"}
        text2={"Empowering Travel Partners Through Curated Global Journeys "}
      />
      {/* <Introduction data={data} /> */}
      <AboutUsSec0 />
      <AboutUsIntro data={data} />
      <AboutUsMission />
      <AboutUsVision />
      <AboutUsSec1 />
      <AboutUsSec2 />
      <AboutUsCredentials
        title={"PREMIER OFFERINGS"}
        desc={"What Makes Us a Preferred DMC Partner "}
        data={credentials}
      />
      <Footer />
    </div>
  );
};
